export type WeightedEntry<T> = readonly [T, number];

/**
 * Returns one entry from `entries`, weighted by each entry's second value.
 * Weights must be positive numbers. Throws if entries is empty.
 */
export function weightedPick<T>(entries: ReadonlyArray<WeightedEntry<T>>): T {
  if (entries.length === 0) {
    throw new Error('weightedPick: entries must not be empty');
  }
  const total = entries.reduce((sum, [, weight]) => sum + weight, 0);
  let roll = Math.random() * total;
  for (const [value, weight] of entries) {
    roll -= weight;
    if (roll < 0) return value;
  }
  return entries[entries.length - 1][0];
}
